import { render, staticRenderFns } from "./FitmentApiData.vue?vue&type=template&id=6def97f2&scoped=true&"
import script from "./FitmentApiData.vue?vue&type=script&lang=js&"
export * from "./FitmentApiData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def97f2",
  null
  
)

export default component.exports